// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"111d3203","79":"5ef6760e","257":"e2c71e88","265":"7b0bc458","316":"dfd9a096","411":"1bd00503","436":"b5d47a70","591":"0821afc9","711":"790563b9","735":"d0548162"}[chunkId] + ".chunk.js";
};